declare namespace $ {

	type $shm_sort_item__click_shm_sort_1 = $mol_type_enforce<
		ReturnType< $shm_sort['option_click'] >
		,
		ReturnType< $shm_sort_item['click'] >
	>
	type $shm_sort_item__sort_order_shm_sort_2 = $mol_type_enforce<
		ReturnType< $shm_sort['sort_order'] >
		,
		ReturnType< $shm_sort_item['sort_order'] >
	>
	type $shm_sort_item__title_shm_sort_3 = $mol_type_enforce<
		ReturnType< $shm_sort['option_label'] >
		,
		ReturnType< $shm_sort_item['title'] >
	>
	type $shm_sort_item__selected_shm_sort_4 = $mol_type_enforce<
		ReturnType< $shm_sort['option_selected'] >
		,
		ReturnType< $shm_sort_item['selected'] >
	>
	type $mol_list__sub_shm_sort_5 = $mol_type_enforce<
		ReturnType< $shm_sort['option_views'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	export class $shm_sort extends $mol_list {
		option_click( id: any, next?: any ): any
		sort_order( next?: string ): string
		option_label( id: any): string
		option_selected( id: any): boolean
		Option( id: any): $shm_sort_item
		option_views( ): readonly(any)[]
		Options( ): $mol_list
		options( ): Record<string, any>
		sort_by( next?: string ): string
		sub( ): readonly(any)[]
	}
	
	export class $shm_sort_item extends $mol_button_minor {
		Descending( ): $mol_icon_sort_ascending
		Ascending( ): $mol_icon_sort_ascending
		icon( ): readonly(any)[]
		selected( ): boolean
		sort_order( next?: string ): string
		sub( ): readonly(any)[]
		attr( ): ({ 
			'selected': ReturnType< $shm_sort_item['selected'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
	}
	
}

//# sourceMappingURL=sort.view.tree.d.ts.map